import React from 'react';
import {
    calculateTotalHoursPerCategory,
    floatToDurationString,
    formatDay,
    getBriefOverviewForDay,
    getEventByCode,
    getWorkdayDuration,
    splitEventsPerDay
} from "../pdfUtils";
import {addHoursToIsoString} from "../../../../utils/DateTimeUtills";
import css from "../../css/PdfHoursExport.module.css";
import useMyTranslation from "../../../../Hooks/useMyTranslation";
import {NoEndWorkdayIndicator} from "../WeekReportTableBriefPdf";

const TotalRow = ({allEvents, transactionsPerDay, workOrderAllocations}) => {
    const totalAllocated = Object.values(workOrderAllocations).flat().reduce((sum, entry) => sum + (entry.allocatedHours || 0), 0);
    const tPdfComm = useMyTranslation('export.pdf.common');

    const topMid = {
        textAlign: 'center',
        verticalAlign: 'top'
    }

    let totalTime = 0;
    let totalPresence = 0;
    let totalTimeWorkLocations = 0;
    const totalBreak = calculateTotalHoursPerCategory(allEvents, "break");
    const totalPrivate = calculateTotalHoursPerCategory(allEvents, "private");
    const totalTravel = calculateTotalHoursPerCategory(allEvents, "travel");
    const totalCustom = calculateTotalHoursPerCategory(allEvents, "custom") + calculateTotalHoursPerCategory(allEvents, "workLocation");


    const calculatedDays = [];

    Object.values(transactionsPerDay).forEach(day => {
        const { totalDuration, geofenceNames, firstInTime, lastOutTime, geofences } = day;
        const workLocations = Array.from(geofenceNames);

        const overview = getBriefOverviewForDay({
            date: day,
            firstInTime: firstInTime,
            lastOutTime: lastOutTime ?? addHoursToIsoString(firstInTime, 15),
            totalWorkLocations: totalDuration,
            workLocations,
            geofences
        }, allEvents);

        totalTime += overview.workdayDuration;
        totalTimeWorkLocations += day.totalDuration;
        totalPresence += geofences.reduce((acc, geofence) => acc + geofence.duration, 0);

        calculatedDays.push(day.day);
    })


    const notCalculatedEvents = allEvents.filter(event => !calculatedDays.find(day => day === formatDay(new Date(event.eventTime))));
    const eventsPerDay = splitEventsPerDay(notCalculatedEvents);

    Object.values(eventsPerDay).forEach(events => {
        const beginWorkday = getEventByCode(events, 'begin_workday', true);
        const endWorkday = getEventByCode(events, 'end_workday', false);

        const day = new Date(events[0].eventTime);

        totalTime += getWorkdayDuration(day, beginWorkday, endWorkday);
    });

    const eventsToday = splitEventsPerDay(allEvents)[formatDay(new Date())];
    const noEndWorkdayToday = eventsToday && !getEventByCode(eventsToday, 'end_workday', false);


    return (
        <tr>
            <td className={`fw-bold ${css.tableHeader}`}>{tPdfComm('total')}</td>
            <td className={`fw-bold ${css.tableHeader}`} colSpan={2} style={topMid}>
                {floatToDurationString(totalTime, true)}
                {noEndWorkdayToday && <NoEndWorkdayIndicator/>}
            </td>
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}>{floatToDurationString(totalBreak, true)}</td>
            <td className={`fw-bold ${css.tableHeader}`} style={{...topMid, borderRight: '5px solid white'}}>
                {floatToDurationString(totalTime - totalBreak - totalPrivate, true)}
                {noEndWorkdayToday && <NoEndWorkdayIndicator/>}
            </td>
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}>{floatToDurationString(totalTravel, true)}</td>
            <td className={`fw-bold ${css.tableHeader}`} style={{...topMid, borderRight: '5px solid white'}}>{floatToDurationString(totalCustom + totalPrivate, true)}</td>
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}/>
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}/>
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}/>
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}/>
            {/* <td className={`fw-bold ${css.tableHeader}`} style={topMid}>{floatToDurationString(totalAllocated, true)}</td> */}
            <td className={`fw-bold ${css.tableHeader}`} style={topMid}/>
        </tr>
    )
}

export default TotalRow;